import { message } from "antd";

export const onClickCopy = (text: string) => {
  navigator.clipboard.writeText(text);
  message.info("Copied to clipboard");
};
